import { AddPaymentMethodModal } from 'components/add-payment-method-modal';

export default function AddCard() {
  return <AddPaymentMethodModal />;
}
